import {useState} from 'react';
import {useScrollEffect} from 'react-viewport-utils';

export const useHasScrolledDown = () => {
  const [hasScrolledDown, setHasScrolledDown] = useState(false);

  useScrollEffect(
    ({isScrollingDown}) => {
      if (isScrollingDown) {
        setHasScrolledDown(isScrollingDown);
      }
    },
    {
      priority: 'low',
    },
  );

  return hasScrolledDown;
};
